import { getLocale } from "../runtime";

const sv_productsshown = /** @type {(inputs: {amount: NonNullable<unknown>, total: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Visar ${inputs.amount} av ${inputs.total} produkter`
};

const productsshown = /** @type {(inputs: {amount: NonNullable<unknown>, total: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_productsshown(inputs)
	return "productsShown";
};

export { productsshown as "productsShown" };